import React, { useMemo } from 'react';
import DayJs from 'utils/Dayjs';

import Tooltip from 'components/Ui/Tooltip';
import { DefaultMark } from 'components/Ui/Mark';

const Course = ({ course }) => {
	// Find latest take
	const take = useMemo(() => {
		return course?.takes?.[0];
	}, [course]);

	// Do not render mark if no take found
	if (!take) return null;

	return (
		<Tooltip content={() =>
			<div className="py-1 px-2 bg-white text-neutral-700 whitespace-nowrap rounded-lg">
				<div className="text-sm font-bold text-neutral-700">
					{take?.exam?.title}
				</div>

				<div className="text-sm font-normal text-neutral-500">
					{DayJs(take?.startDate).format('D. MMM, YYYY')} - {DayJs(take?.endDate).format('D. MMM, YYYY')}
				</div>
			</div>
		}>
			<DefaultMark take={take} />
		</Tooltip>
	);
};

export default Course;